import React, { useContext, useState } from 'react';
import {
  Box,
  Heading,
  Text,
  Textarea,
  Button,
  useToast,
} from '@chakra-ui/react';
import { useStepperContext } from '../../contexts/StepperContext';
import axios from 'axios';

const ApplicationForm = (props) => {
  const { userData, setUserData } = useStepperContext();
  const [sop, setSop] = useState("");

  const orderId = props.orderId;

  const toast = useToast();

  const handleChange = (event) => {
    const { name, value } = event.target;

    const wordCount = value.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount <= maxWordCount) {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: value }));
    } else {
      const truncatedValue = value
        .trim()
        .split(/\s+/)
        .slice(0, maxWordCount)
        .join(' ');

      setUserData((prevUserData) => ({
        ...prevUserData,
        [name]: truncatedValue,
      }));

      alert(
        `Word limit exceeded. Please limit your response to ${maxWordCount} words.`,
      );
    }
  };

  const handleTextareaChange = (event, name) => {
    const inputValue = event.target.value;
    const wordCount = inputValue.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount > maxWordCount) {
      toast({
        title: 'Word Limit Exceeded',
        description: `Please limit your input to ${maxWordCount} words.`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } else {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: inputValue }));
    }
  };

  const formData = {
    sop : sop,
    price : 599,
    paymentStatus: true,
  }

  const token = localStorage.getItem("token")
  // const handleClick = async () => {
  //   await axios.get('http://localhost:8080/sop/review',{params:{formData:formData,
  // }, withCredentials:true})
  //   .then(res => console.log("submitted"))
  //   .catch(err => console.log(err))
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = {
      question1: userData.q1 || '',
      question2: userData.q2 || '',
      question3: userData.q3 || '',
      question4: userData.q3 || '',
      question5 : userData.q3 || '',
      question6 : userData.q3 || '',
      question7 : userData.q3 || '',
      question8 : userData.q3 || '',
      question9 : userData.q3 || '',
      question10 : userData.q3 || '',
      question11 : userData.q3 || '',
      question12 : userData.q3 || '',
      question13 : userData.q3 || '',
      question14 : userData.q3 || '',
      question15 : userData.q3 || '',
      question16 : userData.q3 || '',
      question17 : userData.q3 || '',
      question18 : userData.q3 || '',
      question19 : userData.q3 || '',
      question20 : userData.q3 || '',
      // follow on questions
    };
    try{
    const response = await axios.post('https://glb-api.onrender.com/appforms/apform1',{userData:formData, orderId:orderId, name:"ApplicationDetails"}, {withCredentials:true});
    console.log(response);
    setUserData({});
    toast({
      title: 'Form Submitted',
      description: 'Your data has been submitted successfully.',
      status: 'success',
      duration: 5000,
      isClosable: true,
    });
  } catch (error) {
    console.error(error);
    toast({
      title: 'Error',
      description: 'An error occurred while submitting the form.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  }
};

  const getMaxWordCount = (name) => {
    // Add your logic to determine the max word count based on the name of the textarea
    // For example:
    switch (name) {
      case 'q1':
        return 4;
      case 'q2':
        return 2;
      case 'q3':
        return 10;
      // Add cases for other text areas
      default:
        return 400;
    }
  };

  return (
    <Box mx="auto" mt="4">
      <Heading as="h1" size="xl" mb="4">
        Application Form 1
      </Heading>
      <form >

        <Box mb="10">
          <Text p="5">
            1. Why did you choose your current undergrad major? Any personal
            story?
          </Text>
          <Textarea
            name="q1"
            value={userData.q1 || ''}
            onChange={(event) => handleTextareaChange(event, 'q1')}
            placeholder="Your answer"
          />
        </Box>
        <Box mb="6">
          <Text p="5">
            2. Why Masters/PhD degree and what this education will give you.
            Which concentration in masters and why or what makes you a fit for
            that concentration, what skills you carry to see it as a fit (250
            words max).
          </Text>
          <Textarea
            name="q2"
            value={userData.q2 || ''}
            onChange={(event) => handleTextareaChange(event, 'q2')}
            placeholder="Your answer"
          />
        </Box>
        <Box mb="6">
          <Text p="5">
            3. Immediate Post Masters plan (mention role, possible recruiters
            and geographical focus (if you want to) (200 words max)
          </Text>
          <Textarea
            name="q3"
            value={userData.q3 || ''}
            onChange={(event) => handleTextareaChange(event, 'q3')}
            placeholder="Your answer"
          />
        </Box>
        <Box mb="10">
          <Text p="5">
            Submit Your Existing SOP Here.
          </Text>
          <Textarea
            name="qSOP"
            // value={userData.q1 || ''}
            value={sop}
            onChange={(e)=>setSop(e.target.value)}
            placeholder="Your SOP answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            4. What is your long-term career goal (5-10 years down the line)
          </Text>
          <Textarea
            name="q4"
            value={userData.q4 || ''}
            onChange={(event) => handleTextareaChange(event, 'q4')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            5. Describe your work experience in chronological order, if
            applicable (500 words max)
          </Text>
          <Textarea
            name="q5"
            value={userData.q5 || ''}
            onChange={(event) => handleTextareaChange(event, 'q5')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            6. Any internships you have done, what you learned and how you
            contributed to the organization.
          </Text>
          <Textarea
            name="q6"
            value={userData.q6 || ''}
            onChange={(event) => handleTextareaChange(event, 'q6')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            7. Describe your key academic projects you have done. What learning
            did they impart?
          </Text>
          <Textarea
            name="q7"
            value={userData.q7 || ''}
            onChange={(event) => handleTextareaChange(event, 'q7')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">8. Any research papers/work. Elaborate</Text>
          <Textarea
            name="q8"
            value={userData.q8 || ''}
            onChange={(event) => handleTextareaChange(event, 'q8')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            9. Mention 3 to 5 activities/hobbies you are passionate about. What
            meaning do they add to your life and how do they impact people
            around you? (300-400 words max)
          </Text>
          <Textarea
            name="q9"
            value={userData.q9 || ''}
            onChange={(event) => handleTextareaChange(event, 'q9')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            10. How do you see your future career adding value to society? (150
            words)
          </Text>
          <Textarea
            name="q10"
            value={userData.q10 || ''}
            onChange={(event) => handleTextareaChange(event, 'q10')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            11. What traits differentiate you as a person from your peers? (200
            words max)
          </Text>
          <Textarea
            name="q11"
            value={userData.q11 || ''}
            onChange={(event) => handleTextareaChange(event, 'q11')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            12. Describe your professional achievements (Any three) 300-400
            words. How did these achievements stand out in terms of impact on
            the organization?
          </Text>
          <Textarea
            name="q12"
            value={userData.q12 || ''}
            onChange={(event) => handleTextareaChange(event, 'q12')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            13. What are your most noteworthy extracurricular
            achievements/community activities (school/college/professional)?
            (300 words max)
          </Text>
          <Textarea
            name="q13"
            value={userData.q13 || ''}
            onChange={(event) => handleTextareaChange(event, 'q13')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            14. Have you undertaken any international travel/professional
            opportunities? If yes, please describe (200 words max)
          </Text>
          <Textarea
            name="q14"
            value={userData.q14 || ''}
            onChange={(event) => handleTextareaChange(event, 'q14')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">15. Which newspaper do you read, if any?</Text>
          <Textarea
            name="q15"
            value={userData.q15 || ''}
            onChange={(event) => handleTextareaChange(event, 'q15')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            16. What do you want to be known for in your social circle or in
            society, once you have a comfortable income and savings?
          </Text>
          <Textarea
            name="q16"
            value={userData.q16 || ''}
            onChange={(event) => handleTextareaChange(event, 'q16')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            17. Is there any public figure, currently or in the past, that has
            moved something in you? If yes, what aspect moved you? (100 words)
          </Text>
          <Textarea
            name="q17"
            value={userData.q17 || ''}
            onChange={(event) => handleTextareaChange(event, 'q17')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            18. What was the last book (other than course work) you read? Do you
            have any impressions you would like to share?
          </Text>
          <Textarea
            name="q18"
            value={userData.q18 || ''}
            onChange={(event) => handleTextareaChange(event, 'q18')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            19. How would you contribute to the university/college/department
            community in a way that you would be proud of?
          </Text>
          <Textarea
            name="q19"
            value={userData.q19 || ''}
            onChange={(event) => handleTextareaChange(event, 'q19')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            20. Is there anything else you would like to share that has not been
            covered yet? This can include personal incidents, moments in
            history, or any other aspects of your life.
          </Text>
          <Textarea
            name="q20"
            value={userData.q20 || ''}
            onChange={(event) => handleTextareaChange(event, 'q20')}
            placeholder="Your answer"
          />
        </Box>

        <Button type="submit" colorScheme="blue"  onClick={handleSubmit}>
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default ApplicationForm;